export default {
  EFT: 'eft',
  CREDIT_CARD: 'credit_card',
  CUSTOMER_CREDIT: 'customer_credit',
};
